"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const SvgCenter = (props, ref) => (React.createElement("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1024 1024", fill: "currentColor", className: `Icon ${props?.className || ""}`, ref: ref },
    React.createElement("path", { d: "M512 325.818c-102.865 0-186.182 83.317-186.182 186.182S409.135 698.182 512 698.182 698.182 614.865 698.182 512 614.865 325.818 512 325.818m416.116 139.637c-21.41-194.095-175.476-348.16-369.57-369.571V0h-93.091v95.884c-194.095 21.41-348.16 175.476-369.571 369.57H0v93.091h95.884c21.41 194.095 175.476 348.16 369.57 369.571V1024h93.091v-95.884c194.095-21.41 348.16-175.476 369.571-369.57H1024v-93.091zM512 837.818c-180.13 0-325.818-145.687-325.818-325.818S331.869 186.182 512 186.182 837.818 331.869 837.818 512 692.131 837.818 512 837.818" })));
const ForwardRef = (0, react_1.forwardRef)(SvgCenter);
exports.default = ForwardRef;
